import { Nullable } from '@shared/models/types/primary'

let handler: () => void

export const handlePageVisibility = (
  visibleCallback?: Nullable<() => void>,
  hiddenCallback?: () => void
) => {
  if (handler) {
    document.removeEventListener('visibilitychange', handler)
  }

  handler = () => {
    if (document.visibilityState === 'hidden') {
      return hiddenCallback?.()
    }
    if (visibleCallback) {
      visibleCallback?.()
    }
  }

  document.addEventListener('visibilitychange', handler)
}
